import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.page.html',
  styleUrls: ['./not-found.page.scss']
})
export class NotFoundPage implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  backOnPrevUrl(): void {
    this.location.back()
  }
}
